import { render, staticRenderFns } from "./schoolMain.vue?vue&type=template&id=477303fa&scoped=true"
import script from "./schoolMain.vue?vue&type=script&lang=js"
export * from "./schoolMain.vue?vue&type=script&lang=js"
import style0 from "./schoolMain.vue?vue&type=style&index=0&id=477303fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477303fa",
  null
  
)

export default component.exports